import React from 'react';

import { CARD_SURFACE_CLASS } from './Card';

export function SkeletonCard({ featured = false }) {
  return (
    <div
      className={`${CARD_SURFACE_CLASS} relative min-h-[7.25rem] overflow-hidden px-4 py-5 animate-pulse${
        featured ? ' border-[var(--brand-primary,#1A428A)]/25 bg-[var(--brand-primary,#1A428A)]/90' : ''
      }`}
    >
      <div
        className={`mb-3 h-2.5 w-20 rounded ${featured ? 'bg-white/25' : 'bg-slate-200'}`}
      />
      <div
        className={`mb-3 h-8 w-28 rounded ${featured ? 'bg-white/30' : 'bg-slate-200'}`}
      />
      <div className={`h-2 w-16 rounded ${featured ? 'bg-white/15' : 'bg-slate-100'}`} />
    </div>
  );
}

export function SkeletonChart({ height = 'h-[220px]' }) {
  return (
    <div className={`w-full ${height} ${CARD_SURFACE_CLASS} animate-pulse p-4`}>
      <div className="mb-3 h-3 w-32 rounded bg-slate-200" />
      <div className="mb-6 h-2 w-48 rounded bg-slate-100" />
      <div className="flex h-[120px] items-end gap-2">
        {[65, 40, 80, 55, 90, 45, 70, 60, 85, 50, 75, 40].map((h, i) => (
          <div
            key={i}
            className="flex-1 rounded bg-slate-200"
            style={{ height: `${h}%` }}
          />
        ))}
      </div>
      <div className="mt-3 flex justify-between">
        {[...Array(6)].map((_, i) => (
          <div key={i} className="h-2 w-6 rounded bg-slate-100" />
        ))}
      </div>
    </div>
  );
}

export function SkeletonProductRow() {
  return (
    <div className="grid animate-pulse gap-2 sm:grid-cols-[120px_1fr_auto] sm:items-center">
      <div className="h-3 w-20 rounded bg-slate-200" />
      <div className="h-2.5 rounded bg-slate-200" />
      <div className="h-3 w-14 rounded bg-slate-200" />
    </div>
  );
}
